import React from "react";
import { useState, useEffect } from "react";
import moment from "moment";
import { UNIVERSAL_SEARCH_URL } from "../../../utils/constants";
import profilesvg from "./../../../assets/profile.svg"; 
import userprofile from "./../../../assets/user-profile.svg";
import { Button } from "../../../common/Button/Button";
import CentralizedNotesModal from "../Handholder/CentralizedNotesModal";
export default function UserssDetails(props) {
	const [educationalQualification, setEducationalQualification] = useState();

	useEffect(() => {
		let eQ;
		if (
			props.data &&
			Object.keys(props.data).length &&
			props.userData &&
			Object.keys(props.userData).length
		) {
			eQ = props.userData.customer_profile_data.Education.filter(
				(f) =>
					String(f.value) ===
					String(props.data[0]["educational_qualification"])
			);
			console.log("AJCBDB", eQ);

			if (eQ.length > 0) setEducationalQualification(eQ[0].label);
		}
	}, [props.userData, props.data]);

	

	

	const renderUserData = () => {
		console.log("user details props", props.data, props.userData);

		let temp = props.data.map((e, index) => {
			return (
			<div>
			<section className="user-information">
			<div className="container">
			<div className="row">
				<div className="col-md-12">
					<h3 className="heading">User Information</h3>
				</div> 
			</div>
			<div className="row table-row">
				<div className="col-md-4 col1">
					<div className="inline">
						<h4>Name:</h4>
						<p>{`${e["first_name"]} ${e["last_name"]}`}</p>
					</div>
					<div className="inline">
						<h4>Email ID:</h4>
						<p>{`${e["email"] ?? ""}`}</p>
					</div>
					<div className="inline">
						<h4>Contact No:</h4>
						<p>{`${e["mobile_number"] ?? ""}`}</p>
					</div>
					<div className="inline">
						<h4>Alternate No:{" "}</h4>
						<p>
                        {`${e["alternate_mobile_number"] ?? ""}`}
                        </p>
					</div>
					<div className="inline">
						<h4>Date of Birth:{" "}</h4>
						<p>
                            {moment(e["date_of_birth"]).format("DD/MM/YYYY")}
                        </p>
					</div>
					<div className="inline">
						<h4>Gender:</h4>
						<p>{`${e["gender"] ?? ""}`}</p>
					</div>
				</div>
				<div className="col-md-4 col2">
					<div className="inline">
						<h4>Educational Qualification:{" "}</h4>
						<p>{educationalQualification}</p>
					</div>
					<div className="inline">
						<h4>Other Qualification:{" "}</h4>
						<p>{`${
				 				e["educational_qualification"] === "-1"
				 				? e["other_qualification"]
				 				: "-"
							}`}
                        </p>
					</div>
					<div className="inline">
						<h4>Country:</h4>
						<p>{`${e["country"] ?? ""}`}</p>
					</div>
					<div className="inline">
						<h4>State:</h4>
						<p>{`${e["state"] ?? ""}`}</p>
					</div>
					<div className="inline">
						<h4>City:</h4>
						<p>{`${e["city"] ?? ""}`}</p>
					</div>
					<div className="inline">
						<h4>Pincode:</h4>
						<p>{`${e["pincode"] ?? ""}`}</p>
					</div>
				</div>

				<div className="col-md-4 col3">
					<div className="inner-col">
						<div className="inline"> 
							<img 
							src={userprofile}
							width="auto"
							style={{marginLeft:"4%",cursor:"pointer"}}
							onClick={() => {props.toggleUserProfileModal(e["user_id"])}}
							/>
							<h6 className="conv-mt10">User Profile</h6>	
						</div>

						<div className="btn-wrap"> 
						<Button 
							className="conv-mb15"
							onClick={()=>{props.toggleViewAllNotesModal(e["email"])}}
							style={{float:"left",marginLeft:"10px",}}
							>
							View All Notes
						</Button>

                         
							<Button 
								onClick={()=>{props.toggleViewAllSMSModal(e["email"])}}
								style={{float:"left",marginLeft:"10px",width:"130px"}}
								>
								View All SMS
							</Button>

						</div>
						<br></br><br></br><br></br><br></br>
						<div className="universal-search ">
							<a href="https://webapp.deasra.in/LeadUniversalSearch" target="_blank">
                                <span className="label-link">Go to universal search</span>
                            </a>
						</div>
					</div>
				</div>
			</div>
			</div>
			</section>
			</div>



			);
		});
		return (
			<div>
				<div>
					<span>
						<b>{props.label}</b>
					</span>
				</div>

				{temp}
			</div>
		);
	};
	return props.data.length > 0 ? (
		renderUserData()
	) : (
		<div>
			<span>
				<b>{props.label}</b>
				<br></br>
				<a href="https://webapp.deasra.in/LeadUniversalSearch" target="_blank" style={{marginLeft:""}}>
				<span className="lpm-cons-btns-bordered-filter" style={{fontSize:"15px"}}>Go to universal search</span>
				</a>
				<br></br>
				<span style={{marginLeft:"1.5%" ,fontWeight:"bold"}}>No data found</span>
			</span>
		</div>

		
	);
}
